import ErrorLine from 'components/ErrorLine'
import { getMessage } from 'controllers/SocialServiceController'
import { getRoomById } from 'controllers/VortexController'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getStorageAccount } from 'redux/actions/accountActions'
import { setCurrentRoom } from 'redux/actions/messagesActions'
import CreateHarmonizePost from 'vortex/CreateHarmonizePost'

export default function CreatePost() {
    const { messageId } = useParams()
    const { studios } = useSelector(state => state.account)
    const [hasStudio, setHasStudio] = useState(false)
    const [error, setError] = useState('')
    const dispatch = useDispatch()

    /**
     * If messageId is specified, get the Studio specified by the Message;
     * otherwise, get the private studio/.
     */
    const getRoom = async () => {
        if (studios.length) {
            const { handle } = getStorageAccount()
            console.log(`CreatePost for ${handle} studios`, studios)
            let targetStudio
            if (messageId) {
                const message = await getMessage(messageId)
                if (message) {
                    const { roomId } = message
                    targetStudio = studios.find(st => st._id === roomId)
                }
            }
            if (!targetStudio) {
                targetStudio = studios.find(st => st.name === 'private')
            }
            if (targetStudio) {
                try {
                    const { _id } = targetStudio
                    const room = await getRoomById(_id)
                    dispatch(setCurrentRoom(room))
                    setHasStudio(true)
                } catch (error) {
                    console.error(`Unable to get Studio`, error)
                    setError(`Unable to get Studio`)
                    //displayError(error, setError)
                }
            } else {
                setError('No private studio')
            }
        }
    }
    useEffect(() => {
        getRoom()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <div>
            <ErrorLine error={error} />
            {hasStudio ? <CreateHarmonizePost messageId={messageId} /> : ''}

        </div>
    )
}